// extracted by mini-css-extract-plugin
export default {"spriteAnimation":"startsAnimation_spriteAnimation__UNf4K","frame":"startsAnimation_frame__HJhOX","visible":"startsAnimation_visible__CTGtH","hidden":"startsAnimation_hidden__touTh"};